import React, { useEffect, useRef } from 'react';
import * as PDF417 from 'pdf417-generator';

type Props = {
  price: string
  userFirstName: string
  userLastName: string
  userAddress: string
  userCity: string
  oib: string
  recipient: string
  recipientAddress: string
  recipientCity: string
  model: string
  iban: string
  description: string
  callPrefix?: string
  hidden: boolean
  onBarcodeGenerated?: (canvas: HTMLCanvasElement) => void
}

export const BarCode: React.FC<Props> = (props: Props) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const removeDiacritics = (item: string): string => {
    if (!item) return '';
    return item
      .replace(/š/g, 's')
      .replace(/Š/g, 'S')
      .replace(/Č/g, 'C')
      .replace(/č/g, 'c')
      .replace(/Ć/g, 'C')
      .replace(/ć/g, 'c')
      .replace(/Đ/g, 'd')
      .replace(/đ/g, 'd')
      .replace(/Ž/g, 'Z')
      .replace(/ž/g, 'z');
  };

  useEffect(() => {
    const fullName = `${props.userFirstName} ${props.userLastName}`;
    let price = String(props.price).replace(/[ ,.]/g, '');
    while (price.length < 15) {
      price = `0${price}`;
    }

    const qrCode = `HRVHUB30
EUR
${price}
${removeDiacritics(fullName).toUpperCase()}
${removeDiacritics(props.userAddress).toUpperCase()}
${removeDiacritics(props.userCity).toUpperCase()}
${removeDiacritics(props.recipient).toUpperCase()}
${removeDiacritics(props.recipientAddress).toUpperCase()}
${removeDiacritics(props.recipientCity).toUpperCase()}
${props.iban}
${props.model}
${props.callPrefix ? props.callPrefix : ''}${props.oib !== '0' ? props.oib : 'Vas oib'}
COST
${removeDiacritics(props.description)}`;

    if (canvasRef.current) {
      PDF417.draw(qrCode, canvasRef.current);
      if (props.onBarcodeGenerated) {
        props.onBarcodeGenerated(canvasRef.current);
      }
    }
  }, [props]);

  return (
    <canvas
      ref={canvasRef}
      width="250px"
      height="131px"
      style={{ display: props.hidden ? 'none' : 'block', width: '250px', height: '131px'}}
    />
  );
};

// export const BarCode: React.FC<Props> = (props: Props) => {
//   const fullName = `${props.userFirstName} ${props.userLastName}`
//   let price = props.price.replace(/[ ,.]/g, '')
//   let i
//   for (i = 0; price.length < 15; i++) {
//     price = '0' + price
//     price = `0${price}`
//   }
//   const qrCode = `HRVHUB30
// EUR
// ${price}
// ${removeDiacritics(fullName).toUpperCase()}
// ${removeDiacritics(props.userAddress).toUpperCase()}
// ${removeDiacritics(props.userCity).toUpperCase()}
// ${removeDiacritics(props.recipient).toUpperCase()}
// ${removeDiacritics(props.recipientAddress).toUpperCase()}
// ${removeDiacritics(props.recipientCity).toUpperCase()}
// ${props.iban}
// ${props.model}
// ${props.callPrefix ? props.callPrefix : ''}${props.oib !== '0' ? props.oib : 'Vas oib'}
// COST
// ${removeDiacritics(props.description)}`
//   const barCodeCanvas2 = document.createElement('CANVAS') as HTMLCanvasElement
//   barCodeCanvas2.setAttribute('id', 'barCodeCanvas2')
//   barCodeCanvas2.setAttribute('width', '1200')
//   barCodeCanvas2.setAttribute('height', '400')
//   // PDF417.generate(qrCode, barCodeCanvas2)
//   PDF417.draw(qrCode, barCodeCanvas2);
//   const canvasCode = barCodeCanvas2.toDataURL() || ''
//   function removeDiacritics(item: string) {
//     if (!item) {
//       return ''
//     }
//     item = item.replace(/š/g, 's')
//     item = item.replace(/Š/g, 'S')
//     item = item.replace(/Č/g, 'C')
//     item = item.replace(/č/g, 'c')
//     item = item.replace(/Ć/g, 'C')
//     item = item.replace(/ć/g, 'c')
//     item = item.replace(/Đ/g, 'd')
//     item = item.replace(/đ/g, 'd')
//     item = item.replace(/Ž/g, 'Z')
//     item = item.replace(/ž/g, 'z')
//     return item
//   }
//   return (
//     <img
//       src={canvasCode}
//       alt="qrCode"
//       id="barCodeImage"
//       width="1200"
//       height="400"
//       style={{ display: props.hidden ? 'none' : 'block' }}
//     />
//   )
// }

